import { TimeSlot } from "@clockwise/schema";
import { DateTime } from "luxon";

export const getRangeForLastMonth = (zone: string) => {
  const today = DateTime.now().setZone(zone);

  const start = today.minus({ weeks: 3 }).startOf("week");
  const end = today.endOf("week");

  const rangeMin = {
    date: start.toFormat("yyyy-MM-dd"),
    timeSlot: TimeSlot.T_00_00,
  };
  const rangeMax = {
    date: end.toFormat("yyyy-MM-dd"),
    timeSlot: TimeSlot.T_23_30,
  };
  return { rangeMin, rangeMax };
};
